import { render, staticRenderFns } from "./informatedisclosuredetail.vue?vue&type=template&id=1f658761&scoped=true&"
import script from "./informatedisclosuredetail.vue?vue&type=script&lang=js&"
export * from "./informatedisclosuredetail.vue?vue&type=script&lang=js&"
import style0 from "./informatedisclosuredetail.vue?vue&type=style&index=0&id=1f658761&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f658761",
  null
  
)

export default component.exports